import { FC } from "react";
import { observer } from "mobx-react-lite";
import { MdsPanelContainer } from "@/design-system/components/panel";
import { TemplatesListPageHeader } from "@/pages/templates-list/components/TemplatesListPageHeader";
import { TemplatesListPageList } from "@/pages/templates-list/components/TemplatesListPageList";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { DeleteTemplateModal } from "@/components/modal/delete-template/delete-template-modal";
import { useTabPageStore } from "@/hooks/useTabPageStore";

export const TemplatesListPage: FC = observer(function TemplatesListPage() {
  const page = useTabPageStore("templatesListPage");

  return (
    <>
      <ShareSheetModal store={page.shareSheetModal} />
      <DeleteTemplateModal store={page.deleteTemplateModal} />
      <TemplatesListPageHeader />
      <MdsPanelContainer>
        <TemplatesListPageList />
      </MdsPanelContainer>
    </>
  );
});
